import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const AlignJustifiedIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 7.73333H20M4 16.2667H20M4 12H20"
          stroke={iconColor}
          strokeWidth="1.5"
        />
      </svg>
    </Box>
  );
};
